export enum EmailPreferencesEnum {
	CandidateOnboardingComplete = 1,
	CandidateOnboardingDocumentComplete = 2,
	CandidateOnboardingReferenceComplete = 3,
	CandidateOnboardingBankComplete = 4,
	TimesheetAssignee = 100,
	CandidateAssignee = 101,
	BookingAssignee = 102,
	BookingPlaceholderAssignee = 103,
	TimesheetCandidateStatusUpdate = 200,
	TimesheetClientStatusUpdate = 201,
	TimesheetCandidateQueryUpdate = 202,
	TimesheetClientQueryUpdate = 203,
	DocumentExpiry = 300,
	BookingInterviewAttendanceUpdate = 400,
	BookingTrialAttendanceUpdate = 401,
	PlacementApplication = 500,
	CandidateInterviewConfirmationComplete = 600,
	SMSNotification = 700,
}

export enum WatchersEmailPreferencesEnum {
	UpdateExternalBooking = 111,
	ClientCandidateInterest = 112,
	ClientCandidateInterestSubmit = 113,
	ExternalSubmit = 114,
	DocumentRequestSubmitted = 115,
	ReferenceSubissionConfirmation = 116,
	UpdateOnboard = 117,
	CandidateBankRequestSubmitted = 118,
	AvailabilityEnquiryExternal = 119,
	TimesheetConfirmation = 110,
	PartialTimesheetConfirmation = 120,
}

export enum NotificationMethodEnum {
	InApp = 1,
	Email = 2,
	Both = 3,
}
